import { styled } from '@glitz/react';
import * as React from 'react';
import { NnTestIdProps } from 'webapp/shared/test-ids';

type StockStatus = NordicNest.Api.StockStatus;
type ProductStatus = NordicNest.Api.ProductStatus;

type Props = {
  variantStatus: ProductStatus;
  stockStatus: StockStatus;
};

export const StatusCheck = styled(
  React.memo(({ variantStatus, stockStatus }: Props) => {
    return <Status stockStatus={stockStatus} variantStatus={variantStatus} />;
  }),
);

type CheckProps = {
  stockStatus: NordicNest.Api.StockStatus;
  variantStatus: NordicNest.Api.ProductStatus;
};

const Status = React.memo(({ stockStatus, variantStatus }: CheckProps) => {
  if (variantStatus === 'blocked' || stockStatus === 'outOfStock') {
    return <Red />;
  }

  if (stockStatus === 'preOrdered') {
    return null;
  }

  if (stockStatus === 'backOrdered') {
    if (variantStatus === 'active' || variantStatus === 'news') {
      return null;
    } else {
      return <Red />;
    }
  }

  if (stockStatus === 'unknown' || !stockStatus) {
    return <Gray />;
  }

  return <Green {...NnTestIdProps.StockStatusInStock} />;
});

const Bullet = styled(
  props => (
    <styled.Svg width="6" height="6" viewBox="0 0 7 7" {...props}>
      <circle cx="3.5" cy="3.5" r="3.5" fill="currentColor" />
    </styled.Svg>
  ),
  {
    marginRight: t => t.sharedSpacing.xs,
    flexShrink: 0,
  },
);

const Green = styled(Bullet, {
  color: t => t.stockStatus?.inStock,
});

const Red = styled(Bullet, {
  color: t => t.stockStatus?.outOfStock,
});

const Gray = styled(Bullet, {
  color: t => t.stockStatus?.unknown,
});
